export default {
  NO_SUBSCRIPTION: 'subscription/NO_SUBSCRIPTION',
  LOAD_PAYMENT_SCHEDULE: 'subscription/LOAD_PAYMENT_SCHEDULE',
  LOAD_SUBSCRIPTION: 'subscription/LOAD_SUBSCRIPTION',
  gql: {
    GET_SUBSCRIPTION: `
    query(
      $golfId: String!
      $accountId: String!
      $from: String
    ) {
      getSubscription(
        golfId: $golfId
        accountId: $accountId
        from: $from
      ) {
        id
        totalAmount
        startsAt
        expiresAt
        paymentPlan
        createdAt
        membershipPackage {
          membership {
            name
            amount
          }
          products {
            name
            type
            amount
          }
        }
        statuses {
          name
          createdAt
        }
        installments {
          amount
          dueDate
        }
      }
    }
    `,
    GET_SUBSCRIPTION_FROM_PGB: `
    query(
      $golfId: String!
      $accountId: String!
    ) {
      getSubscriptionFromPGB(
        golfId: $golfId
        accountId: $accountId
      ) {
        totalAmount
        startsAt
        expiresAt
        membershipPackage {
          name
        }
      }
    }
    `,
    GET_LAST_SUBSCRIPTION: `
    query(
      $golfId: String!
      $accountId: String!
    ) {
      getLastSubscription(
        golfId: $golfId
        accountId: $accountId
      ) {
        totalAmount
        startsAt
        expiresAt
        membershipPackage {
          membership {
            name
            amount
          }
          products {
            name
            type
            amount
          }
        }
        entrance
      }
    }
    `,
    GET_ATTACHED_DOCUMENTS: `
    query(
      $subscriptionId: String!
    ) {
      getSubscriptionAttachedDocuments(
        subscriptionId: $subscriptionId
      ) {
        id
        name
        filename
        mimetype
        type
      }
    }
    `,
    TRACK_SUBSCRIPTION: `
    mutation(
      $event: String!
      $channel: String!
      $attributes: String
      $subscriptionId: String!
    ) {
      trackSubscription(
        event: $event
        channel: $channel
        attributes: $attributes
        subscriptionId: $subscriptionId
      ) {
        success
      }
    }
    `,
    CONFIRM_SUBSCRIPTION: `
    mutation(
      $creditCardId: String!
      $subscriptionId: String!
      $paymentSchedule: [Sub_InstallmentInput]
    ) {
      confirmSubscription(
        creditCardId: $creditCardId
        subscriptionId: $subscriptionId
        paymentSchedule: $paymentSchedule
      ) {
        status
        createdAt
        pgbIdAppelcot
      }
    }
    `,
  },
};
